import axios from 'axios';
import { newAPI } from '../../../services';

const url = process.env.REACT_APP_NEW_BASE_API;

const superLogicaAPI = axios.create({
  baseURL: url,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

export const fetchFilters = async url => {
  const response = await newAPI.get(url);
  return response.data;
}

export const fetchFinancialFilters = async userId => {
  const response = await newAPI.get(`${userId}/financial/filters`);
  return response.data;
}

export const fetchUsersSituation = async (userId, token) => {
  newAPI.defaults.headers.common['Authorization'] = token;

  const response = await superLogicaAPI.get(`${userId}/users/establishments/situation`);
  return response.data;
}

export const removeSuperLogicaDebitWarning = async userId => {
  const response = await newAPI.get(`${userId}/deactivate/debit-warning`);
  return response.data;
}